import { FIELD_TYPES } from "constants/template-field-type";
import AssetFieldsConfig from "components/core/asset/fields-config";
import fullParagraphFieldsConfig from "segments/desktop/core-components/full-paragraph/fields-config";
import cardTagConfig from "segments/desktop/core-components/card-tag/fields-config";

export default {
  type: FIELD_TYPES.NESTED,
  label: "Whats New Inner Page Side By Side",
  fields: {
    ...fullParagraphFieldsConfig,
    date: {
      type: FIELD_TYPES.CALENDAR,
      label: "Date"
    },
    tags: {
      type: FIELD_TYPES.MULTIPLE_NESTED,
      label: "Tags",
      nestedConfig: {
        type: FIELD_TYPES.NESTED,
        fields: {
          ...cardTagConfig
        }
      }
    },
    rightSectionPaddingTop: {
      type: FIELD_TYPES.TEXT,
      label: "Left Section Padding Top"
    },
    asset: {
      type: FIELD_TYPES.NESTED,
      label: "Asset",
      fields: {
        ...AssetFieldsConfig
      }
    }
  }
};
